import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const BASE_URL = `https://inspection.tdcp.gop.pk`;
// const BASE_URL = `http://localhost:5001`;

/** User Role */
export const getUserRole = () => {
  const userDetails = sessionStorage.getItem("userDetails");
  if (!userDetails) return null;

  try {
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails?.role || parsedDetails?.roles || null;
  } catch (error) {
    console.error("Failed to parse userDetails from sessionStorage:", error);
    return null;
  }
};

export const getUserPermissions = () => {
  const userDetails = sessionStorage.getItem("userDetails");
  if (!userDetails) return null;

  try {
    const parsedDetails = JSON.parse(userDetails);
    return {
      role: parsedDetails?.role || parsedDetails?.roles || null,
      service: parsedDetails?.Service || null,
      module: parsedDetails?.module || null
    };
  } catch (error) {
    console.error("Failed to parse userDetails from sessionStorage:", error);
    return null;
  }
}; 

/** For Inspection App */
export const getReportsData = async (token) => {
  try {
    const API_URL = `${BASE_URL}/api/get_submitted_forms`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching reports data:", error);
    throw error;
  }
};
export const signUpInspectionUser = async (data) => {
  try {
    const API_URL = `${BASE_URL}/api/signup`;
    const response = await axios.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating user data:", error);
    throw error;
  }
};
export const updateInspectionUser = async (userId, data, token) => {
  try {
    const API_URL = `${BASE_URL}/api/update_user/${userId}`;
    const response = await axios.put(API_URL, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const deleteUser = async (id, token) => {
  try {
    const API_URL = `${BASE_URL}/api/delete/${id}`;
    const response = await axios.delete(API_URL,{
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

export const getTaskData = async (token) => {
  try {
    const API_URL = `${BASE_URL}/api/get_tasks`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks data:", error);
    throw error;
  }
};
//get user activity
export const getUserActivity = async (token) => {
  try {
    const API_URL = `${BASE_URL}/api/get_track_of_activty`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks data:", error);
    throw error;
  }
};

export const getUserMonthlyActivity = async (id, token) => {
  try {
    const API_URL = `${BASE_URL}/api/user-logs-activity/${id}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks data:", error);
    throw error;
  }
};

export const getInspectionUsersData = async (token) => {
  try {
    const API_URL = `${BASE_URL}/api/get_users`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching reports data:", error);
    throw error;
  }
};
export const getSingleTask = async (token, taskId) => {
  try {
    const API_URL = `${BASE_URL}/api/get_tasks/${taskId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.get(API_URL, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching reports data:", error);
    throw error;
  }
};

/** For E-Ticketing */

const getETicketingToken = () => {
  const userDetails = sessionStorage.getItem("userDetails");
  if (!userDetails) return null;

  try {
    const parsedDetails = JSON.parse(userDetails);
    return parsedDetails?.token || parsedDetails?.accessToken || null;
  } catch (error) {
    console.error("Failed to parse userDetails from sessionStorage:", error);
    return null;
  }
};

const ETicketheaders = {
  "x-tenant-token": "tdcp_live_6dac3af74bf76cbd6115f029ebcdccb7bbd066df31aa2fd190783c5f1be6c46c"
};
const ETicketting_URL = "https://neweticketingapi.tdcp.gop.pk/api";
// const ETicketting_URL = "http://localhost:3010/api";


// Create axios instance with base config
export const axiosInstance = axios.create({
  baseURL: ETicketting_URL,
  headers: ETicketheaders,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getETicketingToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const addPeopleCount = async (date, peopleCount) => {
  const response = await axiosInstance.post("/people-counts", { date, count: peopleCount });
}

export const useAddPeopleCountMutation = () => {
  return useMutation({
    mutationFn: ({ date, peopleCount }) => addPeopleCount(date, peopleCount),
  });
}

const getDashboardStats = async (serviceId, startDate, endDate, cityId) => {
  const cityQuery = cityId ? `&city_id=${cityId}` : '';
  const response = await axiosInstance.get(`/dashboard/get-stats?service_id=${serviceId}&start_date=${startDate}&end_date=${endDate}${cityQuery}`);
  return response.data?.data;
}

export const useGetDashboardStats = (serviceId, startDate, endDate, cityId) => {
  return useQuery({
    queryKey: ["dashboardStats", serviceId, startDate, endDate, cityId],
    queryFn: () => getDashboardStats(serviceId, startDate, endDate, cityId),
    enabled: !!serviceId,
  });
}

/** User Permissions */

export const getPermission = async (id) => {
  try {
    const URL = `${ETicketting_URL}/permissions/${id}`;
    const response = await axiosInstance.get(URL);
    console.log(response.data);
    return response.data;

  } catch (error) {
    console.error("Error getting permission")
  }
}
// Get All Permissions
export const getPermissions = async () => {
  try {
    const url = `${ETicketting_URL}/permissions`;
    const response = axiosInstance.get(url);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error getting permissions")
  }
}
export const LoginApi = async (data) => {
  try {
    const API_URL = `/auth/login`;
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error.response.data.message);
    throw new Error(error.response.data.message || "Login failed");
  }
};
// ✅ Get cities (all or by ID)
export const getServiceCities = async (id) => {
  try {
    const url = id ? `/cities/${id}` : `/cities`;
    const response = await axiosInstance.get(url);
    console.log(response.data)
    return response.data;
  } catch (error) {
    console.error("Error getting Cities", error);
    throw error;
  }
};

// ✅ Update city
export const updateServiceCities = async (data, id) => {
  try {
    const response = await axiosInstance.put(`/cities/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating service city", error);
    throw error;
  }
};

// ✅ Create city
export const createServiceCity = async (data) => {
  try {
    const response = await axiosInstance.post(`/cities`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating service city", error);
    throw error;
  }
};

// ✅ Delete city
export const deleteServiceCity = async (id) => {
  try {
    const response = await axiosInstance.delete(`/cities/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting service city", error);
    throw error;
  }
};

// ✅ Get Manager Services --Services
export const getSMServices = async (id) => {
  try {
    const url = id ? `/services/${id}` : `/services`;
    const response = await axiosInstance.get(url);
    console.log(response.data)
    return response.data;
  } catch (error) {
    console.error("Error getting SM Services", error);
    throw error;
  }
}

// ✅ Update Service Manager --Services
export const updateSMServices = async (data, id) => {
  try {
    const response = await axiosInstance.put(`/services/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating SM Services", error);
    throw error;
  }
};

// ✅ Create Service MAnager -- Services
export const createSMServices = async (data) => {
  try {
    const response = await axiosInstance.post("/services", data);
    return response.data;
  } catch (error) {
    console.error("Error Creating Services", error);
    throw error;
  }
}

// ✅ delete Service Manager --Services
export const DeleteSMServices = async (id) => {
  try {
    const response = await axiosInstance.delete(`/services/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error Deleteing SM Service", error);
    throw error;
  }
}

// ✅ Get Routes based on Service Id
export const getAllRoutes = async (id) => {
  try {
    const response = await axiosInstance.get(`/routes?service_id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error creating Routes", error);
    throw error;
  }
}

// ✅ Create Route Based on Service Id
export const createRoute = async (data) => {
  try {
    const response = await axiosInstance.post("/routes", data);
    return response.data;
  } catch (error) {
    console.error("Error creating Route", error);
    throw error;
  }
};

//✅  Update Route based on Service Id
export const UpdateRoute = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/routes/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating Route", error);
    throw error;
  }
}

// ✅ Delete Route based on Service Id
export const DeleteRoute = async (id) => {
  try {
    const response = await axiosInstance.delete(`routes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error Deleteing Route", error);
    throw error;
  }
}
// E-Ticketing User Creation
export const ETAddUser = async (data) => {
  try {
    const response = await axiosInstance.post("/users", data);
    return response.data;
  } catch (error) {
    console.error("Error Creating User", error);
    throw error;
  }
}
// E-Ticketting User Updation
export const ETUpdateUser = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/users/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating User", error);
    throw error;
  }
}
// E-Ticketting User Deleteion
export const ETUserDelete = async (id) => {
  try {
    const response = await axiosInstance.delete(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error Deleteing User", error);
    throw error;
  }
}
// E-Ticketting User Fetch
export const ETGetUsers = async (serviceId) => {
  try {
    const response = await axiosInstance.get(`/users?service_id=${serviceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Users", error);
    throw error;
  }
}
// Route Timings Addition
export const createTimings = async (data) => {
  try {
    const response = await axiosInstance.post("/timings", data);
    return response.data;
  } catch (error) {
    console.error("Error Creating timings", error);
    throw error;
  }
}
// Route Timings Updation
export const updateTimings = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/timings/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating timings", error);
    throw error;
  }
}
// Route Timings Deleteion
export const deleteTimings = async (id) => {
  try {
    const response = await axiosInstance.delete(`/timings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error Deleteing timings", error);
    throw error;
  }
}
// Route Timings Fetch
export const getTimings = async (routeId) => {
  try {
    const response = await axiosInstance.get(`/timings?route_id=${routeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Timings", error);
    throw error;
  }
}
// Route Pricing Addition
export const createPrice = async (data) => {
  try {
    const response = await axiosInstance.post("/prices", data);
    return response.data;
  } catch (error) {
    console.error("Error Creating Pricing", error);
    throw error;
  }
}
// Route Pricing Updation
export const updatePricing = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/prices/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating Pricing", error);
    throw error;
  }
}
// Route Pricing Deleteion
export const deletePricing = async (id) => {
  try {
    const response = await axiosInstance.delete(`/prices/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error Deleteing Pricing", error);
    throw error;
  }
}
// Route Pricing Fetch
export const getPricing = async (routeId) => {
  try {
    const response = await axiosInstance.get(`/prices?route_id=${routeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Pricing", error);
    throw error;
  }
}
